<div class="container mt-5">
    <div class="card card-primary">
        <div *ngIf="loader==true">
            <app-loader style="text-align: center;"></app-loader>
          </div>
        <!-- /.card-header -->
        <!-- form start -->
        <div class="row">
            <form id="quickForm" [formGroup]="eventForm" (ngSubmit)="onSubmit()">
                <div class="card-body">
                    <div class="row">
                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Owner First Name' }}" [required]="true"
                                    [control]="eventForm.controls['firstName']" [isInline]="false">
                                    <app-input formControlName="firstName"></app-input>
                                </app-form-field>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Owner Last Name' }}" [required]="true"
                                    [control]="eventForm.controls['lastName']" [isInline]="false">
                                    <app-input formControlName="lastName"></app-input>
                                </app-form-field>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Email' }}" [required]="true"
                                    [control]="eventForm.controls['email']" [isInline]="false">
                                    <app-input formControlName="email"></app-input>
                                </app-form-field>
                            </div>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Phone Number' }}" [required]="true"
                                    [control]="eventForm.controls['phoneNo']" [isInline]="false">
                                    <app-input formControlName="phoneNo"></app-input>
                                </app-form-field>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Business Name' }}" [required]="true"
                                    [control]="eventForm.controls['fullName']" [isInline]="false">
                                    <app-input formControlName="fullName"></app-input>
                                </app-form-field>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Address' }}" [required]="true"
                                    [control]="eventForm.controls['address']" [isInline]="false">
                                    <app-input formControlName="address"></app-input>
                                </app-form-field>
                            </div>
                        </div>

                    </div>

                    <div class="row">

                        
                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Country' }}" [required]="true"
                                    [control]="eventForm.controls['countryId']" [isInline]="false">
                                    <!-- <datalist id="suggestions1">
                                        <option *ngFor="let item of countryList" value="{{item.value}}">{{item.label}}</option>
                                      </datalist>
                                      <input formControlName="countryId" class="form-control form-control-lg" control="eventForm.controls['countryId']" autoComplete="on" list="suggestions1" />
                                       -->
                                       <app-select [items]="countryList" formControlName="countryId"></app-select>
                                </app-form-field>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'City' }}" [required]="true"
                                    [control]="eventForm.controls['city']" [isInline]="false">
                                    <app-input formControlName="city"></app-input>
                                </app-form-field>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Zip Code'}}" [required]="true"
                                    [control]="eventForm.controls['zipCode']" [isInline]="false">
                                    <app-input formControlName="zipCode"></app-input>
                                </app-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        
                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Daily Limit' }}" [required]="true"
                                    [control]="eventForm.controls['dailyLimit']" [isInline]="false">
                                    <app-input formControlName="dailyLimit"></app-input>
                                </app-form-field>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Credit Limit'}}" [required]="true"
                                    [control]="eventForm.controls['creditLimit']" [isInline]="false">
                                    <app-input formControlName="creditLimit"></app-input>
                                </app-form-field>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Password'}}" [required]="true"
                                    [control]="eventForm.controls['password']" [isInline]="false">
                                    <app-input formControlName="password"></app-input>
                                </app-form-field>
                            </div>
                        </div>
                        
                        <!-- <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'IsTestMode' }}" [required]="true"
                                    [control]="eventForm.controls['isTestMode']" [isInline]="false">
                                    <app-select [items]="isTestAccount" formControlName="isTestMode"></app-select>
                                </app-form-field>
                            </div>
                        </div> -->
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <div class="form-group">
                                <app-form-field label="{{ 'Discount Template' }}" [required]="true"
                                    [control]="eventForm.controls['discountTemplateId']" [isInline]="false">
                                    <app-select [items]="DiscountTemplates" formControlName="discountTemplateId"></app-select>
                                    <!-- <datalist id="suggestions">
                                        <option *ngFor="let item of DiscountTemplates" value="{{item.value}}">{{item.label}}</option>
                                      </datalist>
                                      <input formControlName="discountTemplateId" class="form-control form-control-lg"
                                       control="eventForm.controls['discountTemplateId']" autoComplete="on" list="suggestions" />
                                       -->
                                </app-form-field>
                            </div>
                        </div>
                        <div class="col-4">
                            <app-form-field label="{{ 'Retailer Type' }}" [required]="true"
                                [control]="eventForm.controls['retailerType']" [isInline]="false">
                                <app-select [items]="retailerType" formControlName="retailerType"></app-select>
                            </app-form-field>

                        </div>
                        <div class="col-4">
                            <div class="form-group">

                                <app-form-field label="{{ 'Retailer Plan Type' }}" [required]="true"
                                    [control]="eventForm.controls['retailerPlanType']" [isInline]="false">
                                    <app-select [items]="retailerPlanType"
                                        formControlName="retailerPlanType"></app-select>

                                </app-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.card-body -->
                <div class="card-footer">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button> &nbsp;&nbsp;
                    <button type="button" class="btn btn-outline-dark"
                        (click)="activeModal.dismiss({ refresh: false })">
                        Close
                    </button>
                </div>
            </form>
        </div>
    </div>


</div>
<script src="../../plugins/jquery/jquery.min.js"></script>
<script src="../../plugins/bootstrap/js/bootstrap.bundle.min.js"></script>
<!-- Select2 -->
<script src="../../../../assets/plugins/select2/js/select2.full.min.js"></script>

<script>
    $(function () {
        //Initialize Select2 Elements
        $('.select2').select2()

        //Initialize Select2 Elements
        $('.select2bs4').select2({
            theme: 'bootstrap4'
        })
    })
</script>